import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MetadataLoadingStage, UserContextService } from '../services/user-context.service';
import { SharedService } from '../services/shared-service';
import { Observable } from 'rxjs';
import { filter, switchMap, map } from 'rxjs/operators';

export const OrganizationGuard: CanActivateFn = (route, state): Observable<boolean> => {
  // Inject the required services
  const userContextService = inject(UserContextService);
  const sharedService = inject(SharedService);

  return sharedService.appInitialized$.pipe(
    filter((initialized) => initialized), // Wait for appInitialized$ to emit true
    switchMap(() => userContextService.MetadataLoadingStage$), // Check if organization data is loaded
    filter((loaded) => loaded >= MetadataLoadingStage.OrganizationLoaded), // Ensure organization data is fully loaded
    map(() => true) // Allow route activation
  );
};
